module.exports = __webpack_public_path__ + "d308073b/img/chevron-down-icon.5542f65c.svg";